import styled, { css } from 'styled-components'

export const Container = styled.div`
    margin: 2rem 0 0 0;
    text-align: center;
    flex: auto;

    display: flex;
    flex-direction: column;
`

export const ContainerFranchise = styled.div`
    flex: auto;
    overflow: auto;
`

export const ContainerButton = styled.div`
    width: 100%;

    ${props => props.isDisabled && css`
        button{
            opacity: 0.5;
            width: 100%;
            pointer-events: none;
        }
    `}
`